import React, { useState } from "react";
import CustomButton from "../CustomButton";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

function RMNCard({ service, title }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const openModal = (imageUrl) => {
    setCurrentImage(imageUrl);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setCurrentImage(null);
  };

  const handleDownload = () => {
    if (!currentImage) return;
    const link = document.createElement("a");
    link.href = currentImage;
    link.download = currentImage.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  const DownloadIco = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5l5-5m-5-7v12" /></svg>
  );



  return (
    <>
      {Object.keys(service).length && (
        <div className="container">
          <div className="section-title2 primary3 text-start" data-aos="fade-up">
            <span>Retail Marketing</span>
            <h2>{service?.highlist_title}</h2>

          </div>
          <div className="row  rmncard justify-content-center g-4 col-12">
            {service.services_list &&
              service.services_list.length &&
              service.services_list.map((member) => {
                const isEmptyTargetUrl =
                  member.target_url === "" ? true : false;
                return (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div
                      className="single-team2 rmn-img rmn-item glass-effect" data-aos="fade-up"
                    >
                      <div className="team-content">
                        <h4 className="name">{member.title}</h4>
                        <p className="designation">
                          {member.services_sub_title}
                        </p>
                        <p className="designation">
                          {member.sub_section_title2
                            ? member.sub_section_title2
                            : ""}
                        </p>
                        <div className=" gap-3">
                          <ul className="social-links d-flex justify-content-center align-items-center flex-row gap-3">
                            {member.instagram_url && (
                              <li>
                                <a
                                  href={`${member.instagram_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bxl-instagram" />
                                </a>
                              </li>
                            )}
                            {member.facebook_url && (
                              <li>
                                <a
                                  href={`${member.facebook_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bxl-facebook" />
                                </a>
                              </li>
                            )}
                            {member.twitter_url && (
                              <li>
                                <a
                                  href={`${member.twitter_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bxl-twitter" />
                                </a>
                              </li>
                            )}
                            {member.pinterest_url && (
                              <li>
                                <a
                                  href={`${member.pinterest_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bxl-pinterest-alt" />
                                </a>
                              </li>
                            )}

                            {member.linkedin_url && (
                              <li>
                                <a
                                  href={`${member.linkedin_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="bx bxl-linkedin" />
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="team-image">
                        <div onClick={() => openModal(member.icon_image)} className="image">
                          <img src={member.icon_image} alt="member" />

                          <div
                            className="zoom-icon"
                          // onClick={() => openLightbox(index)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                              <path
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314M11 8v6m-3-3h6"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 text-center mt-4">
                      <a
                        href={!isEmptyTargetUrl && member.target_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button
                          className="eg-btn btn--primary2 capsule"
                          disabled={isEmptyTargetUrl}
                        >
                          Click Here To Get Started!<CustomButton />
                        </button>
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
          {isOpen && (
            <div className="modal-overlay" onClick={closeModal}>
              <div className="modal-content">
                <span className="close-modal" onClick={closeModal}>
                  &times;
                </span>
                <img
                  src={currentImage}
                  alt="Modal View"
                  className="modal-image"
                />
              </div>
            </div>
          )}

          {isOpen && (
            <Lightbox
              mainSrc={currentImage}
              onCloseRequest={() => setIsOpen(false)}
              toolbarButtons={[
                <button
                  key="download"
                  onClick={handleDownload}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  {DownloadIco} Download
                </button>,
              ]}
            />
          )}

        </div>
      )}
    </>
  );
}

export default RMNCard;